import {JSONValue} from 'util/Types';

/**
 * @deprecated
 */
// TODO(BNCH-31259): Delete this function after completion of UB M1
// This function is DEPRECATED, see data-frames/table/cellToChipItemIds for current function
function isStringArray(jsonValue: JSONValue): jsonValue is Array<string> {
  return Array.isArray(jsonValue) && jsonValue.every((arrayElement) => typeof arrayElement === 'string');
}

/**
 * Extract item ids from cell, using stringIsItemId predicate
 *
 *   - If cell has item ids, then return them
 *   - Otherwise, return null
 *
 * Keep in sync with benchling/insights/warehouse/cell_to_item_api_ids.py
 * @deprecated
 */
// TODO(BNCH-31259): Delete this function after completion of UB M1
// This function is DEPRECATED, see data-frames/table/cellToChipItemIds for current function
export default function cellToItemIds(
  cell: JSONValue,
  stringIsItemIdFn: (stringValue: string) => boolean
): Array<string> | null {
  if (typeof cell === 'string' && stringIsItemIdFn(cell)) {
    return [cell];
  }
  if (isStringArray(cell) && cell.every((stringValue) => stringIsItemIdFn(stringValue))) {
    return cell;
  }
  return null;
}
